import { Injectable } from '@angular/core';
import { FundOverviewService } from '@products/services/fund-overview.service';
import { AnalizyRatingState, ProductDetailConfiguration } from '@types';
import { Subject } from 'rxjs';
import analizyRatingQuery from '@graphql/overview/analizy-rating.graphql';
import { Product } from '@products/models/product';

@Injectable({
  providedIn: 'root',
})
export class AnalizyRatingService {
  private state: AnalizyRatingState = {};
  private analizyRatingSubject: Subject<AnalizyRatingState>;

  constructor(private overviewService: FundOverviewService) {
    this.analizyRatingSubject = new Subject();
  }

  public get analizyRatingState(): Subject<AnalizyRatingState> {
    return this.analizyRatingSubject;
  }

  public populate(
    productDetailConfiguration: ProductDetailConfiguration
  ): void {
    this.overviewService
      .register(analizyRatingQuery, {
        fundId: productDetailConfiguration.fundId,
        shareClassCode: productDetailConfiguration.shareClassCode,
      })

      .subscribe((product: Product) => {
        if (product) {
          this.mapState(product);
        }
      });
  }

  mapState(product: Product) {
    const ratings = product?.shareClasses[0]?.ratings;
    if (ratings) {
      this.state = {
        category: ratings.analizyRatingCategory,
        effectiveDate: ratings.analizyRatingEffectiveDate,
        months12: ratings.analizyRating12Months,
        months36: ratings.analizyRating36Months,
      };
    }
    this.analizyRatingSubject.next(this.state);
  }
}
